import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr';
import { Observable } from 'rxjs';
import { TenantsContactModel, TenantsModel } from '../../../models';
import { TenantSettingModel } from '../../../models/tenantSettingModel';
import { CommonService, SettingsService, TenantService } from '../../../services';

@Component({
    selector: 'app-update-info',
    templateUrl: './update-info.component.html',
    styleUrls: ['./update-info.component.scss']
})
export class UpdateInfoComponent implements OnInit {
    model: TenantsModel = new TenantsModel();
    tenantSettingModel: TenantSettingModel = new TenantSettingModel();
    saved: boolean = false;
    contacts: TenantsContactModel[] = [];
    jobTitleList: any[] = [];
    constructor(private settingService: SettingsService, private toastr: ToastsManager, private router: Router, private route: ActivatedRoute, private tenantsService: TenantService, private commonService: CommonService) { }

    ngOnInit() {

        this.route.params.subscribe((params) => {
            const id = params['id'];
            if (id) {
                this.loadData(+id);
            }
        });

    }

    loadSetting(accountId: number) {
        this.settingService.getValue('ContactPublicPageData', accountId, 0).subscribe((response) => {
            if (response.Success) {
                if (response.Data.Value) {
                    this.tenantSettingModel = JSON.parse(response.Data.Value);
                }

            }

        });
    }

    getJobTitle(contact: any) {
        if (this.jobTitleList.some(x => x.Id == contact.JobTypeId)) {
            return this.jobTitleList.filter(x => x.Id == contact.JobTypeId)[0].Name;
        }
        return "";
    }
    public loadData(id: number) {

        this.tenantsService.getTenant(id)
            .catch((err: any) => {
                // this.toastr.error(err, 'Error');
                return Observable.throw(err);
            }).finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response) => {
                if (response.Data) {

                    this.model = response.Data;

                    if (this.model.ImageUrl == null || this.model.ImageUrl == undefined) {
                        this.model.ImageUrl = "/assets/images/upload-empty.png";
                    }
                    //this.model.Company = account.Company;
                    if (this.model.PermiseType) {
                        // this.loadSubPremiseTypes(this.model.PermiseType.toString());
                    }
                    this.loadJobTitles();

                    this.loadSetting(this.model.AccountId);
                }
            });

        this.tenantsService.getAllTenantContacts(id)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    //this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response) => {
                this.contacts = response.Data.length > 0 ? response.Data : [];
            });


    }
    public validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    public saveChanges() {
        var anyError = false;
        if (this.model.Name == undefined || this.model.Name == '' || this.model.Name == null) {
            this.toastr.error(`Butiksnamn / Name of the store is required.`, 'Required Field');
            return;
        }

        if (this.contacts.length > 0) {

            this.contacts.forEach(element => {
                // if(element.FullName == undefined || element.FullName == '' || element.FullName == null){
                //     this.toastr.error(`Namn/Name for ${this.getJobTitle(element)} is required.`, 'Required Field');
                //     anyError = true;

                // }

                if (element.EmailAddress != '' && element.EmailAddress != undefined && element.EmailAddress != null) {
                    if (!this.validateEmail(element.EmailAddress)) {
                        this.toastr.error(`Invalid email address for ${this.getJobTitle(element)}`, "Invalid Format");
                        anyError = true;
                    }
                }
            });

            if (anyError) {
                return;
            }
        }

        var date = new Date();
        var offset = date.getTimezoneOffset();

        this.model.OffSet = offset;
        this.model.LastUpdatedByCustomer = date;
        if (this.model.Email) {
            if (!this.validateEmail(this.model.Email)) {
                this.toastr.error("Invalid Email Address", "Error");
                return;
            }
        }
        this.model.IsFromPublicPage = true;
        // this.showSpinner = true;
        this.tenantsService.saveTenantPublic(this.model)
            .catch((err: any) => {
                this.toastr.error(err, 'Error');
                return Observable.throw(err);
            }).finally(() => {
                setTimeout(() => {
                    //this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response) => {

                this.contacts.forEach(contact => {

                    this.tenantsService.saveTenantContact(contact)
                        .catch((err: any) => {
                            this.toastr.error(err, 'Error');
                            return Observable.throw(err);
                        }).finally(() => {
                            setTimeout(() => {
                                //this.showSpinner = false;
                            }, 1000);
                        })
                        .subscribe((response) => {

                        });

                });

                // this.toastr.success("Contact Updated Successfully", 'Success');
                this.ngOnInit();
                this.saved = true;

            });
    }

    public loadJobTitles() {

        this.commonService.getAllJobTitles(this.model.AccountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
            })
            .subscribe((response: any) => {
                this.jobTitleList = response.Data ? response.Data : [];
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/components/tenants/public/update-info.component.ts